import * as React from "react";
import { Circle } from "lucide-react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { cn } from "utils/shadcn";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square w-4 h-4 sm:w-[1.125rem] sm:h-[1.125rem] border border-black/50 rounded-full shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring data-[state=checked]:bg-[#FE4D01] data-[state=checked]:border-[#FE4D01] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex justify-center items-center">
        <Circle className="w-[0.85rem] h-[0.85rem] text-white fill-[#FE4D01]" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

const RadioGroupItem1 = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square w-3.5 sm:w-4 h-3.5 sm:h-4 border border-black data-[state=checked]:border-[#FE4D01] rounded-full shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex flex-shrink-0 justify-center items-center">
        <Circle className="w-[0.3125rem] sm:w-[0.425rem] h-[0.3125rem] sm:h-[0.425rem] fill-[#FE4D01] text-[#FE4D01]" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem1.displayName = RadioGroupPrimitive.Item.displayName;

const RadioGroupItem2 = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square data-[state=checked]:bg-[#FE4D01] size-3.5 sm:size-4 border border-[#D5D7DA] data-[state=checked]:border-[#FE4D01] rounded-full shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex flex-shrink-0 justify-center">
        <Circle className="size-[0.3125rem] sm:size-1.5 fill-white text-white" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem2.displayName = RadioGroupPrimitive.Item.displayName;

const RadioGroupItem3 = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square w-3.5 sm:w-4 h-3.5 sm:h-4 border border-[#181818]/10 data-[state=checked]:border-[#FE4D01] rounded-full shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex flex-shrink-0 justify-center items-center">
        <Circle className="size-[0.46875rem] sm:size-[0.59375rem] fill-[#FE4D01] text-[#FE4D01]" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem3.displayName = RadioGroupPrimitive.Item.displayName;

export {
  RadioGroup,
  RadioGroupItem,
  RadioGroupItem1,
  RadioGroupItem2,
  RadioGroupItem3,
};
